"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Table = _interopRequireDefault(require("../../../preact-components/table/Table"));

var _Loader = require("../Loader");

var _EmptyTable = _interopRequireDefault(require("../EmptyTable"));

var _EmptyResults = require("../EmptyResults");

var _AnalyticsDateFormatter = _interopRequireDefault(require("../AnalyticsDateFormatter"));

var _urlGenerator = _interopRequireDefault(require("../../../preact-components/utils/urlGenerator"));

var _assets = _interopRequireDefault(require("../../../preact-components/assets"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getRateData = function getRateData(total, company) {
  var totalNumber = parseInt("".concat(total));

  if (totalNumber === 0) {
    return '0 / 0 (%)';
  }

  var rate = parseInt("".concat(company)) / totalNumber * 100;
  return "".concat(company, " / ").concat(total, " (").concat(Math.round((rate + Number.EPSILON) * 100) / 100, "%)");
};

var IdeationTrendsTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeationTrendsTable, _Component);

  var _super = _createSuper(IdeationTrendsTable);

  function IdeationTrendsTable() {
    var _this;

    (0, _classCallCheck2.default)(this, IdeationTrendsTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      ideationTrends: [],
      sorting: {
        order: 'votes',
        direction: 'desc'
      },
      isLoading: true,
      isV2: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ideaUrl", function (idea) {
      return "".concat((0, _globals.default)('communityUrl')).concat((0, _urlGenerator.default)('ideas', idea.title, idea.idea_id));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSortChange", function (attr) {
      if (attr === _this.state.sorting.order) {
        return;
      }

      var newSorting = {
        order: attr,
        direction: 'desc'
      };

      _this.fetchIdeationTrends(newSorting);
    });
    return _this;
  }

  (0, _createClass2.default)(IdeationTrendsTable, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fetchIdeationTrends(this.state.sorting);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(prevProps) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate || this.props.selectedCompany !== prevProps.selectedCompany)) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.fetchIdeationTrends(this.state.sorting);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetchIdeationTrends",
    value: function () {
      var _fetchIdeationTrends = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(sorting) {
        var res;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  isLoading: true,
                  sorting: sorting
                });
                _context3.prev = 1;
                _context3.next = 4;
                return this.props.fetchData('/analyticsV2/fetchIdeationTrends', '', {
                  sortOrder: sorting.order,
                  sortDirection: sorting.direction
                });

              case 4:
                res = _context3.sent;
                this.setState({
                  ideationTrends: res.data.records,
                  isLoading: false,
                  isV2: !!(res.data.records[0] && 'created_by' in res.data.records[0])
                });
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                this.setState({
                  isLoading: false
                });

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 8]]);
      }));

      function fetchIdeationTrends(_x2) {
        return _fetchIdeationTrends.apply(this, arguments);
      }

      return fetchIdeationTrends;
    }()
  }, {
    key: "getModel",
    value: function getModel() {
      var _this$props = this.props,
          ideaStatusList = _this$props.ideaStatusList,
          defaultIdeaStatus = _this$props.defaultIdeaStatus,
          selectedCompany = _this$props.selectedCompany;
      var initialValue = {};
      var mappedStatus = ideaStatusList.reduce(function (mapped, item) {
        mapped[item.id] = item;
        return mapped;
      }, initialValue);
      var tooltipMap = {
        votes: 'When filtered on all companies: Shows the total votes from all the companies.\n\n When a specific company is filtered: Shows the number of votes by the company users out of total votes and the percentage of votes.',
        replies: 'When filtered on all companies: Shows the total replies from all the companies. \n\n When a specific company is filtered: Shows the number of replies by the company users out of total replies and the percentage of replies.',
        views: 'When filtered on all companies: Shows the total views from all the companies. \n\n When a specific company is filtered: Shows the number of views by the company users out of total views and the percentage of views.'
      };
      var createdBy = this.state.ideationTrends.reduce(function (isBlank, ideationTrend) {
        return isBlank || ideationTrend.created_by !== null;
      }, false);

      if (this.state.isV2) {
        return [{
          header: 'Title',
          accessor: 'title',
          cell: function cell(idea) {
            return (0, _preact.h)("div", {
              className: "idea-title-cell"
            }, (0, _preact.h)("a", {
              href: (0, _absoluteUrlRuntime.resolveUrl)("/ideas/".concat(idea.idea_id)),
              target: "_blank",
              rel: "noreferrer"
            }, idea.title), (0, _preact.h)("a", {
              className: "link-icon",
              href: (0, _absoluteUrlRuntime.resolveUrl)("/ideas/".concat(idea.idea_id)),
              target: "_blank",
              rel: "noreferrer"
            }, (0, _preact.h)(_assets.default, {
              icon: "externalLink",
              width: 16,
              height: 16
            })));
          },
          size: 'l'
        }, {
          header: "Idea status (".concat(_AnalyticsDateFormatter.default.displayFormattedDateInFilter(this.props.startDate), ")"),
          accessor: 'idea_status_start',
          cell: function cell(idea) {
            return (0, _preact.h)(StatusCell, {
              item: mappedStatus[idea.status_id_start] || defaultIdeaStatus
            });
          },
          size: 'm'
        }, {
          header: "Idea status (".concat(_AnalyticsDateFormatter.default.displayFormattedDateInFilter(this.props.endDate), ")"),
          accessor: 'idea_status_end',
          cell: function cell(idea) {
            return (0, _preact.h)(StatusCell, {
              item: mappedStatus[idea.status_id_end] || defaultIdeaStatus
            });
          },
          size: 'm'
        }, {
          header: 'Created by',
          accessor: 'created_by',
          cell: function cell(idea) {
            return idea.created_by;
          },
          size: createdBy ? 'm' : 'xs'
        }, {
          header: 'Votes',
          accessor: 'votes',
          cell: function cell(idea) {
            return selectedCompany ? getRateData(idea.votes, idea.company_votes) : idea.votes;
          },
          size: 's right',
          sorting: 'votes',
          tooltipMessage: tooltipMap.votes
        }, {
          header: 'Replies',
          accessor: 'replies',
          cell: function cell(idea) {
            return selectedCompany ? getRateData(idea.replies, idea.company_replies) : idea.replies;
          },
          size: 's right',
          sorting: 'replies',
          tooltipMessage: tooltipMap.replies
        }, {
          header: 'Views',
          accessor: 'views',
          cell: function cell(idea) {
            return selectedCompany ? getRateData(idea.views, idea.company_views) : idea.views;
          },
          size: 's right',
          sorting: 'views',
          tooltipMessage: tooltipMap.views
        }];
      }

      return [{
        header: 'Title',
        accessor: 'title',
        cell: function cell(idea) {
          return (0, _preact.h)("div", {
            className: "idea-title-cell"
          }, (0, _preact.h)("a", {
            href: (0, _absoluteUrlRuntime.resolveUrl)("/ideas/".concat(idea.idea_id)),
            target: "_blank",
            rel: "noreferrer"
          }, idea.title), (0, _preact.h)("a", {
            className: "link-icon",
            href: (0, _absoluteUrlRuntime.resolveUrl)("/ideas/".concat(idea.idea_id)),
            target: "_blank",
            rel: "noreferrer"
          }, (0, _preact.h)(_assets.default, {
            icon: "externalLink",
            width: 16,
            height: 16
          })));
        },
        size: 'l'
      }, {
        header: "Idea status (".concat(_AnalyticsDateFormatter.default.displayFormattedDateInFilter(this.props.startDate), ")"),
        accessor: 'idea_status_start',
        cell: function cell(idea) {
          return (0, _preact.h)(StatusCell, {
            item: mappedStatus[idea.status_id_start] || defaultIdeaStatus
          });
        },
        size: 'm'
      }, {
        header: "Idea status (".concat(_AnalyticsDateFormatter.default.displayFormattedDateInFilter(this.props.endDate), ")"),
        accessor: 'idea_status_end',
        cell: function cell(idea) {
          return (0, _preact.h)(StatusCell, {
            item: mappedStatus[idea.status_id_end] || defaultIdeaStatus
          });
        },
        size: 'm'
      }, {
        header: 'Votes',
        accessor: 'votes',
        cell: function cell(idea) {
          return idea.votes;
        },
        size: 's right',
        sorting: 'votes'
      }, {
        header: 'Replies',
        accessor: 'replies',
        cell: function cell(idea) {
          return idea.replies;
        },
        size: 's right',
        sorting: 'replies'
      }, {
        header: 'Views',
        accessor: 'views',
        cell: function cell(idea) {
          return idea.views;
        },
        size: 's right',
        sorting: 'views'
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          sorting = _this$state.sorting,
          ideationTrends = _this$state.ideationTrends,
          isLoading = _this$state.isLoading;

      if (isLoading) {
        return (0, _preact.h)(_EmptyTable.default, {
          model: this.getModel()
        }, (0, _preact.h)(_Loader.Loader, {
          parentCustomClass: "dashboard-table-loader"
        }));
      } else if (ideationTrends.length > 0) {
        return (0, _preact.h)(_Table.default, {
          model: this.getModel(),
          rows: ideationTrends,
          classes: ['ideation-trends'],
          onSortChange: this.onSortChange,
          sort: sorting,
          "data-element-name": "ideation trends sort button",
          "data-track-type": "click"
        });
      }

      return (0, _preact.h)(_EmptyTable.default, {
        model: this.getModel()
      }, (0, _preact.h)(_EmptyResults.EmptyResults, null));
    }
  }]);
  return IdeationTrendsTable;
}(_preact.Component);

function StatusCell(_ref) {
  var item = _ref.item;
  if (!item) return null;
  return (0, _preact.h)("div", {
    style: {
      background: item.backgroundColor,
      color: item.textColor
    },
    className: "idea-status-label"
  }, item.name);
}

var _default = IdeationTrendsTable;
exports.default = _default;